import { trpc } from '@web/lib/trpc';

export const useListNotifications = (offset: number) => {
  return trpc.notification.getNotifications.useQuery(
    { offset, limit: 10 },
    {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  );
};

export const useListNotificationsUnread = () => {
  return trpc.notification.getNotifications.useQuery(
    { limit: 5, offset: 0 },
    {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  );
};
